import React from 'react';
import { CheckIcon, CreditCardIcon } from 'lucide-react';
import { PRICE, PRICE_BEFORE, PRODUCT_IMAGE, offerIncludes, offerRows } from '../data/gymklar';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-slate-900 px-5 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-218" data-mp="1mm7imuvep9ed">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12 lg:items-center" data-id="element-219" data-mp="1hpqva2w16z2c">
        <div className="px-3 sm:px-0 lg:col-span-6" data-id="element-220" data-mp="tzwfpdkbuwee">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-221" data-mp="ozrz7njf61o6">
            Oppdag hele <em className="text-red-300" data-id="element-222" data-mp="13wre7wglowso">ENGELSK KLAR™</em>-pakken
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-stone-50/70" data-id="element-223" data-mp="13uoegkpnbpar">
            Hele engelskåret – ferdig planlagt. Klar til timen på 5 minutter.
          </p>
          <img src={PRODUCT_IMAGE} alt="" className="mx-auto mt-12 hidden w-full max-w-sm drop-shadow-2xl lg:block" data-id="element-224" data-mp="2famu57fbx9ky" />
        </div>

        <div id="offer-card" className="scroll-mt-16 rounded-3xl bg-stone-50 p-6 text-slate-900 shadow-2xl shadow-black/40 sm:p-11 lg:col-span-6" data-id="element-225" data-mp="2affy8lsax96l">
          <p className="text-sm font-semibold text-slate-900/60" data-id="element-226" data-mp="ui9069yr0qmi">Hele pakken inneholder</p>

          <ul className="mt-5 divide-y divide-slate-900/10 border-y border-slate-900/10" data-id="element-227" data-mp="zjg6e4l8thr2">
            {offerRows.map(row => <li key={row.label} className="flex gap-4 py-4" data-id="element-228" data-mp="13ip0xbo3xjno">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-229" data-mp="6tzdz6xmi0uu">
                  <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-230" data-mp="bs12i7dtisdp" />
                </span>
                <span data-id="element-231" data-mp="ftm9xd7l2egi">
                  <span className="block font-medium leading-snug" data-id="element-232" data-mp="fsb3t6qo0um8">{row.label}</span>
                  <span className="mt-0.5 block text-sm leading-snug text-slate-900/65" data-id="element-233" data-mp="kmp7dwfhe81z">{row.detail}</span>
                </span>
              </li>)}
          </ul>

          <div className="mt-8 flex flex-col items-center gap-2 text-center sm:flex-row sm:items-end sm:justify-between sm:gap-4 sm:text-left" data-id="element-234" data-mp="3o9fp9oq6hjvz">
            <div className="sm:pb-2" data-id="element-235" data-mp="vdwdar3hdqpp">
              <p className="text-sm font-medium text-slate-900/70" data-id="element-236" data-mp="qgxf9xgp4zm8">Introduksjonspris</p>
              <p className="mt-1 text-base text-slate-900/60" data-id="element-237" data-mp="155k5wvbrxdsr">
                Før <s className="decoration-red-700 decoration-2" data-id="element-238" data-mp="154qwfmlfka6x">{PRICE_BEFORE}</s>
              </p>
            </div>
            <p className="font-serif text-7xl leading-none tracking-tight text-slate-900 sm:text-8xl" data-id="element-239" data-mp="108tghhe2x5uo">
              {PRICE}
            </p>
          </div>
          <p className="mt-3 flex items-center justify-center gap-2 text-sm text-slate-900/70 sm:justify-end" data-id="element-240" data-mp="7iti81e32r0s">
            <CreditCardIcon className="h-4 w-4" aria-hidden="true" data-id="element-241" data-mp="lj4czfiikpr8" />
            Engangsbetaling. Ingen abonnement.
          </p>

          <CtaButton label="Få hele pakken nå" className="mt-8 w-full" data-id="element-242" data-mp="hic44ndk0mvh" />

          <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-slate-900/60" data-id="element-243" data-mp="1wv5616mev0cs">
            {offerIncludes.map(item => <li key={item} data-id="element-244" data-mp="20enh8b329gna">{item}</li>)}
          </ul>
        </div>
      </div>
    </section>;
}